import styled from 'styled-components';
import {
  COLOR_CV_1,
  COLOR_CV_3,
  COLOR_CV_6,
  COLOR_NEUTRAL_10,
} from 'constants/colors';
import {
  Menu,
} from 'antd';

export const StyledAntdMenuItem = styled(Menu.Item)`
  font-size: 0.875rem;
  font-weight: 400;
  display: flex;
  align-items: center;

  &.ant-menu {
    &-item:hover,
    &-item-active,
    &:not(&-inline) &-submenu-open,
    &-submenu-active,
    &-submenu-title:hover {
      color: ${COLOR_CV_3};
      fill: ${COLOR_CV_3};
    }

    &-item,
    &-submenu-title {
      fill: ${COLOR_NEUTRAL_10};
      transition: fill 0.3s;

      &:active {
        background-color: ${COLOR_CV_1};
      }

      &-icon {
        width: 11.5px;
        height: 11.5px;
      }

      &::after {
        border-color: ${COLOR_CV_6};
      }

      &-selected {
        color: ${COLOR_CV_6};
        fill: ${COLOR_CV_6};
        background-color: ${COLOR_CV_1} !important; // Because of ant class precedence

        &::after {
          opacity: 1;
          transform: scaleY(1);
        }
      }
    }
  }
`;
